const noindex = document.createElement('meta');
noindex.name = 'robots';
noindex.content = 'noindex';
document.head.appendChild(noindex);
